const title = 'title is-7 mb-1'
const subtitle = 'subtitle is-7 mb-1'
const item = 'is-size-7 mb-1'
const itemStrong = 'is-size-7 mb-1 has-text-weight-bold is-italic'

export const langCGU = {
  fr: {
    title: `WSurf - Conditions générales d'utilisation (CGU)`,
    articles: [
      {
        text: `Conditions générales d'utilisation (CGU)`,
        type: 'h1',
        cl: title,
      },
      {
        text: `Le Service en ligne WSurf est géré par l’EI FKW, 12 rue du levant à Saint Point Lac 25160 (France).`,
        type: 'p',
        cl: item,
      },
      {
        text: `Avant d'utiliser ou de s’inscrire au Service en ligne, chaque Utilisateur doit lire attentivement le présent Contrat de licence de l’Utilisateur Final (« Contrat »).
L'utilisation du Service en ligne WSurf suppose l’acceptation, par l'Utilisateur, de l’intégralité du présent Contrat. Cette acceptation sera réputée avoir la même valeur qu’une signature manuscrite de la part de l'Utilisateur.`,
        type: 'p',
        cl: item,
      },
      { text: `Courriel de contact : wsurf@fkwave.com`, type: 'p', cl: item },
      { text: `Définitions`, type: 'h1', cl: title },
      { text: `On désignera par la suite :`, type: 'p', cl: item },
      {
        text: `Service en ligne : le service en ligne WSurf et l'ensemble de ses pages et écrans.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Base de données : la base de données utilisée par le Service en ligne.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Services : le résultat du traitement des données fournies par l’Utilisateur. `,
        type: 'p',
        cl: item,
      },
      {
        text: `Produits : le contenu numérique ou service auquel il est possible d’accéder, soit au coup par coup sans inscription (version « utilisateur occasionnel »), soit par une inscription intégrée dans le Service en ligne, correspondant à l’une des versions « utilisateur gratuit » ou «utilisateur abonné ».`,
        type: 'p',
        cl: item,
      },
      {
        text: `Éditeur : la personne, morale ou physique, responsable de l'édition et du contenu du Service en ligne.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Utilisateur : l’internaute ou le mobinaute utilisant le Service en ligne.`,
        type: 'p',
        cl: item,
      },
      { text: `Objet`, type: 'h1', cl: title },
      {
        text: `1. L'objet principal du Service en ligne est de traiter de façon statistique les données relatives à des sessions de navigation à titre de loisir fournies par l’Utilisateur au format .gpx ou.fit , et de visualiser les résultats de ce traitement sous une forme adaptée (tableaux, graphes, cartes).`,
        type: 'p',
        cl: item,
      },
      {
        text: `2. Le Service en ligne est édité par l’EI FKW, de façon totalement indépendante.`,
        type: 'p',
        cl: item,
      },
      {
        text: `3. Version « utilisateur occasionnel » : l’Utilisateur accède aux Services de façon occasionnelle, sans être inscrit au Service en ligne. Les données fournies par l’Utilisateur ne sont pas enregistrées dans la Base de données. Les Produits fournis sont limités aux résultats du traitement des données fournies pour la session de navigation, au moment de l’utilisation du Service en ligne.`,
        type: 'p',
        cl: item,
      },
      {
        text: `4. Version « utilisateur gratuit » : elle permet à l’Utilisateur, inscrit en version « utilisateur gratuit », d’enregistrer dans la Base de données les données de 10 sessions de navigation au maximum. Les Produits fournis comprennent dans ce cas les résultats du traitement des données de chaque session de navigation ainsi que leur agrégation et leur présentation sous la forme de tableaux, graphes et cartes.`,
        type: 'p',
        cl: item,
      },
      {
        text: `5. Version « utilisateur abonné » : elle permet à l’Utilisateur, inscrit en version « utilisateur abonné », d’enregistrer dans la Base de données les données de 100 sessions de navigation au maximum par an. Les Produits fournis comprennent dans ce cas les résultats du traitement des données de chaque session de navigation ainsi que leur agrégation  et leur présentation sous la forme de tableaux, graphes et cartes. L’abonnement est d’une durée de 12 mois à compter de sa date de création ou de renouvellement et doit être régulièrement renouvelé pour continuer d’accéder à l’ensemble des Produits pour l’ensemble des données enregistrées par l’Utilisateur. Dans le cas où l’abonnement n’est pas renouvelé à sa date d’échéance, l’  « Utilisateur abonné » devient automatiquement « Utilisateur gratuit » et ne peut accéder qu’aux données et Produits relatifs aux 10 dernières sessions de navigation qu’il a enregistrées. `,
        type: 'p',
        cl: item,
      },
      {
        text: `6. EI FKW ne garantit pas la fiabilité des données fournies par l’Utilisateur.`,
        type: 'p',
        cl: item,
      },
      { text: `Compte dans le Service en ligne`, type: 'h1', cl: title },
      { text: `1. Création`, type: 'h2', cl: item },
      {
        text: `L’Utilisateur créant un compte sur le Service en ligne a la possibilité d’y accéder en se connectant grâce aux identifiants fournis lors de son inscription. L’Utilisateur est entièrement responsable de la protection du mot de passe qu’il a choisi. En cas d’oubli de mot de passe, il a la possibilité d’en choisir un nouveau. Ce mot de passe constitue la garantie de la confidentialité des informations contenues dans son compte et l’Utilisateur s'interdit donc de le transmettre ou de le communiquer à un tiers. A défaut, l'Éditeur du Service en ligne ne pourra être tenu pour responsable des accès non autorisés au compte d'un utilisateur.`,
        type: 'p',
        cl: item,
      },
      { text: `2. Suspension ou suppression`, type: 'h2', cl: item },
      {
        text: `L’Éditeur se réserve le droit exclusif de bloquer l’accès au Service en ligne ou de supprimer le compte de tout Utilisateur qui aurait contrevenu au présent Contrat ou encore tout compte inactif depuis au moins une année.
Ladite suspension ou suppression ne sera pas susceptible de constituer un dommage pour l'Utilisateur exclu qui ne pourra prétendre à aucune indemnité de ce fait.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Droits et obligations de l'Utilisateur`,
        type: 'h1',
        cl: title,
      },
      {
        text: `1. L’Utilisateur s’engage à faire un usage personnel et non-commercial des données produites par le Service en ligne.`,

        type: 'p',
        cl: item,
      },
      {
        text: `2. Chaque Utilisateur est libre de fermer son compte sur le Service en ligne. Pour ceci, l'Utilisateur doit suivre la procédure de suppression figurant dans le Service en ligne.`,
        type: 'p',
        cl: item,
      },
      {
        text: `3. L’Utilisateur a accès uniquement aux données et résultats de leur traitement pour les données qu’il a enregistrées. L’Utilisateur n’a pas accès aux données et résultats de leur traitement d’autres Utilisateurs.`,
        type: 'p',
        cl: item,
      },
      { text: `Droits et obligations de l'Éditeur`, type: 'h1', cl: title },
      { text: `1. Données des Utilisateurs`, type: 'h2', cl: item },
      {
        text: `L’Éditeur s'engage à ne pas communiquer les données fournies par les Utilisateurs.`,
        type: 'p',
        cl: itemStrong,
      },
      { text: `2. Accès au Service en ligne `, type: 'h2', cl: item },
      {
        text: `Les données enregistrées via le Service en ligne sont hébergées sur les serveurs d’un prestataire externe auquel l’Éditeur sous-traite la prestation d’hébergement.
La responsabilité de l'Éditeur ne peut être engagée en raison d'une indisponibilité technique de la connexion, qu'elle soit due notamment à un cas de force majeure, à une maintenance, à une mise à jour, à une modification, à une intervention de l'hébergeur, à une grève interne ou externe, à une panne de réseau, à une coupure d'alimentation électrique, ou encore à une mauvaise configuration ou utilisation du périphérique de l'Utilisateur.
L’Utilisateur admet connaitre les limitations et contraintes propres au réseau internet et, à ce titre, reconnaît notamment l’impossibilité d’une garantie totale de la sécurisation des échanges de données. L'Éditeur n’est pas tenu responsable des dommages résultant du Service en ligne tels que la perte de données, l’intrusion, virus, rupture du service, ou autres.
L'impossibilité totale ou partielle d'utiliser les Produits notamment pour cause d'incompatibilité du matériel ne peut donner lieu à aucun dédommagement, remboursement ou mise en cause de la responsabilité de l'Éditeur, sauf dans le cas d'un vice caché avéré, de non-conformité ou de défectuosité. L’Utilisateur abonné dispose de un mois maximum (à compter de la date d'abonnement) pour se manifester. Au-dela de ce délai, aucune réclamation ne sera acceptée.`,
        type: 'p',
        cl: item,
      },
      { text: `3. Responsabilité`, type: 'h2', cl: subtitle },
      {
        text: `L’Éditeur ne pourra en aucun cas être tenu responsable d'un dysfonctionnement, d'une indisponibilité d'accès, d'une mauvaise utilisation, d'une mauvaise configuration du périphérique de l'Utilisateur, ou encore de l'emploi d'un périphérique peu usité ou obsolète par l'Utilisateur.`,
        type: 'p',
        cl: item,
      },
      { text: `Droits de propriété intellectuelle`, type: 'h1', cl: title },
      {
        text: `Le code source du Service en ligne WSurf ainsi que les méthodes d'analyse et de représentation des données mises au point par FKW sont utilisables sous licence CC BY-NC-SA 4.0 (voir lien en bas de cette page).`,
        type: 'p',
        cl: item,
      },
      {
        text: `Droit applicable, médiation et juge compétent`,
        type: 'h1',
        cl: title,
      },
      {
        text: `Le présent Contrat est soumis à l’application du droit français. L’Éditeur conserve le droit de les modifier à tout moment.
Les litiges qui pourraient survenir dans le cadre de l’exécution des présentes conditions d’utilisation seront réglés en priorité par la voie d’un règlement amiable.
A défaut d’accord entre les parties et pour les Utilisateurs en France, le Tribunal Judiciaire de Besançon (France) est le seul compétent pour résoudre les litiges.`,
        type: 'p',
        cl: item,
      },
    ],
    accept: `J'ai lu et j'accepte les CGU figurant ci-dessus`,
  },
  eng: {
    title: `WSurf - Terms of Service (TOS)`,
    articles: [
      {
        text: `Terms of service (TOS)`,
        type: 'h1',
        cl: title,
      },
      {
        text: `The WSurf Online Service is managed by EI FKW, 12 rue du levant in Saint Point Lac 25160 (France).`,
        type: 'p',
        cl: item,
      },
      {
        text: `Before using or registering for the Online Service, each User must carefully read this End User License Agreement (“Agreement”).
The use of the WSurf Online Service implies acceptance, by the User, of the entirety of this Agreement. This acceptance will be deemed to have the same value as a handwritten signature from the User.
`,
        type: 'p',
        cl: item,
      },
      { text: `Contact email : wsurf@fkwave.com`, type: 'p', cl: item },
      { text: `Definitions`, type: 'h1', cl: title },
      { text: `We will subsequently designate :`, type: 'p', cl: item },
      {
        text: `Online service: the WSurf online service and all of its pages and screens.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Database: the database used by the Online Service.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Services: the result of the processing of data provided by the User.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Products: the digital content or service to which it is possible to access, either on a case-by-case basis without registration (“occasional user” version), or by registration integrated into the Online Service, corresponding to one of the “user free” or “subscribed user” versions.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Publisher: the person, legal or natural, responsible for the publication and content of the Online Service.`,
        type: 'p',
        cl: item,
      },
      {
        text: `User: the Internet user or Mobile user using the Online Service.`,
        type: 'p',
        cl: item,
      },
      { text: `Objet`, type: 'h1', cl: title },
      {
        text: `1. The main purpose of the Online Service is to statistically process data relating to leisure browsing sessions provided by the User in .gpx or.fit format, and to visualize the results of this processing in a form adapted (tables, graphs, maps).`,
        type: 'p',
        cl: item,
      },
      {
        text: `2. The Online Service is published by EI FKW, completely independently.`,
        type: 'p',
        cl: item,
      },
      {
        text: `3. "Occasional user" version: the User accesses the Services on an occasional basis, without being registered for the Online Service. The data provided by the User is not saved in the Database. The Products provided are limited to the results of the processing of the data provided for the browsing session, at the time of using the Online Service.
`,
        type: 'p',
        cl: item,
      },
      {
        text: `4. "Free user" version: this allows the User, registered in the "free user" version, to save the data of a maximum of 10 browsing sessions in the Database. The Products provided include in this case the results of the data processing of each browsing session as well as their aggregation and presentation in the form of tables, graphs and maps.`,
        type: 'p',
        cl: item,
      },
      {
        text: `5. "Subscriber user" version: this allows the User, registered in the "subscriber user" version, to save in the Database the data of a maximum of 100 browsing sessions per year. The Products provided include in this case the results of the data processing of each browsing session as well as their aggregation and presentation in the form of tables, graphs and maps. The subscription is for a period of 12 months from its date of creation or renewal and must be regularly renewed to continue to access all the Products for all the data recorded by the User. In the event that the subscription is not renewed on its expiry date, the "Subscribed User" automatically becomes a "Free User" and can only access the data and Products relating to the last 10 browsing sessions that he recorded. `,
        type: 'p',
        cl: item,
      },
      {
        text: `6. EI FKW does not guarantee the reliability of the data provided by the User.`,
        type: 'p',
        cl: item,
      },
      { text: `Account in the Online Service`, type: 'h1', cl: title },
      { text: `1. Creation`, type: 'h2', cl: item },
      {
        text: `The User creating an account on the Online Service has the possibility of accessing it by logging in using the identifiers provided when registering. The User is entirely responsible for the protection of the password he has chosen. If the password is forgotten, he can choose a new one. This password constitutes the guarantee of the confidentiality of the information contained in his account and the User is therefore prohibited from transmitting it or communicating it to a third party. Failing this, the Publisher of the Online Service cannot be held responsible for unauthorized access to a user's account.
`,
        type: 'p',
        cl: item,
      },
      { text: `2. Suspension or deletion`, type: 'h2', cl: item },
      {
        text: `The Publisher reserves the exclusive right to block access to the Online Service or to delete the account of any User who has violated this Agreement or any account that has been inactive for at least one year.
Said suspension or deletion will not be likely to constitute damage for the excluded User who will not be able to claim any compensation for this fact.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Rights and obligations of the User`,
        type: 'h1',
        cl: title,
      },
      {
        text: `1. The User agrees to make personal and non-commercial use of the data produced by the Online Service.`,

        type: 'p',
        cl: item,
      },
      {
        text: `2. Each User is free to close his account on the Online Service. For this, the User must follow the deletion procedure contained in the Online Service.`,
        type: 'p',
        cl: item,
      },
      {
        text: `3. The User has access only to the data and results of their processing for the data he has recorded. The User does not have access to the data and results of their processing of other Users.`,
        type: 'p',
        cl: item,
      },
      {
        text: `Rights and obligations of the Publisher`,
        type: 'h1',
        cl: title,
      },
      { text: `1. User Data`, type: 'h2', cl: item },
      {
        text: `The Publisher undertakes not to communicate the data provided by the Users.`,
        type: 'p',
        cl: itemStrong,
      },
      { text: `2. Access to the Online service`, type: 'h2', cl: item },
      {
        text: `The data recorded via the Online Service is hosted on the servers of an external service provider to which the Publisher subcontracts the hosting service.
The Publisher cannot be held liable for technical unavailability of the connection, whether due in particular to a case of force majeure, maintenance, updating, modification, intervention of the host, an internal or external strike, a network failure, a power cut, or even incorrect configuration or use of the User's device.
The User admits knowing the limitations and constraints specific to the Internet network and, as such, acknowledges in particular the impossibility of a total guarantee of the security of data exchanges. The Publisher is not liable for damages resulting from the Online Service such as loss of data, intrusion, virus, service disruption, or others.
The total or partial impossibility of using the Products, in particular due to incompatibility of the equipment, cannot give rise to any compensation, reimbursement or questioning of the Publisher's liability, except in the case of a proven hidden defect. , non-compliance or defect. The subscribed User has a maximum of one month (from the date of subscription) to manifest. Beyond this period, no complaint will be accepted.`,
        type: 'p',
        cl: item,
      },
      { text: `3. Responsability`, type: 'h2', cl: subtitle },
      {
        text: `The Publisher can in no way be held responsible for a malfunction, unavailability of access, misuse, improper configuration of the User's device, or even the use of a device little used or obsolete by the User.`,
        type: 'p',
        cl: item,
      },
      { text: `Droits de propriété intellectuelle`, type: 'h1', cl: title },
      {
        text: `The source code of the WSurf Online Service as well as the analysis and data representation methods developed by FKW can be used under CC BY-NC-SA 4.0 license (see link at the bottom of this page).`,
        type: 'p',
        cl: item,
      },
      {
        text: `Applicable law, mediation and competent judge`,
        type: 'h1',
        cl: title,
      },
      {
        text: `This Contract is subject to the application of French law. The Publisher retains the right to modify them at any time.
Disputes that may arise in connection with the execution of these terms of use will be settled as a matter of priority by means of an amicable settlement.
In the absence of an agreement between the parties and for Users in France, the Judicial Court of Besançon (France) has sole jurisdiction to resolve disputes.`,
        type: 'p',
        cl: item,
      },
    ],
    accept: `I have read and accept the TOS listed above`,
  },
}
